export default __webpack_public_path__ + "static/media/pinterest.3c140bd0.svg";